// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Season__wrapper--XDEQV","collapsed":"Season__collapsed--3Fxeg"};


//////////////////
// WEBPACK FOOTER
// ./src/app/views/Season/Season.css
// module id = RoGZ
// module chunks = 12